<script>
    import { Router, Link, Route, navigate } from "svelte-routing";
    import Header from "../components/header.svelte"
    import { isUserDbAdmin } from './stores.js';
    //import Home from "./routes/home.svelte";

    export var auth;


    export let location;
    location = location;

    function goRegister() {
      navigate("/register", { replace: true });
  }


var password;
var email;
var resetModal;
var recupMail;

  function login(){
    auth.signInWithEmailAndPassword(email, password)
  .then((userCredential) => {
    // Signed in
    var user = userCredential.user;
    navigate("/user", { replace: true });
    
    
    
  })
  .catch((error) => {
    var errorCode = error.code;
    var errorMessage = error.message;
    alert(errorMessage)
  });
  }
  
  document.body.addEventListener('keyup', function (e) {
  if (e.keyCode == 13) {
    // Simulate clicking on the submit button.
    login();
  }
});

function showResetModal(){
    resetModal.style.display ="flex";
}



function resetMdp(){
    if(recupMail != ""){
        auth.sendPasswordResetEmail(recupMail).then(resetModal.style.display="none")
    }
}

</script>







<main>
    <Header>
        <div class="elm">A propos</div>
        <div class="elm">Contact</div>
    </Header>
    
    <form class="form">
        <p style="font-size :3rem;user-select:none;">Se connecter</p>
        <input bind:value={email} autocomplete="email" class="inputt" type="email" placeholder="E-mail">
        <input bind:value={password} autocomplete="current-password" class="inputt" type="password" placeholder="Mot de passe">
            <p class="forgot" on:click={showResetModal}>Mot de passe oublié ?</p>
        <!--<p class="forgot" on:click={goRegister}>S'inscrire</p>-->
        <button type='submit' class="submit" on:click|preventDefault={login}><img src="https://img.icons8.com/ios-glyphs/60/ffffff/arrow.png" alt="fleche"/></button>
    </form>
    <div class="resetModal" bind:this={resetModal} on:click|self={resetModal.style.display="none"}>
    <input type="email" bind:value={recupMail} class="resetInput" placeholder="Email de récupération">
    <button on:click={resetMdp} class="rst-btn">Envoyer</button>
    </div>
</main>
 


<style>
    main{
        display: flex;
        flex-direction: column;
        width: 100vw;
        min-height: 100vh;
        background-color: #262626;
        align-items: center;
    }
    .elm{
        margin-right: 20px;
        cursor: pointer;
    }

    .form{
        margin-top: 20vh;
        width: 30vw;
        height: fit-content;
        border-radius: 66px;
        background: #262626;
        box-shadow:  20px 20px 56px #151515,
         -20px -20px 56px #373737;
         display: flex;
         flex-direction: column;
         align-items: center;
         color: white;
         font-family: 'Poppins', sans-serif;
        font-weight: 400;
        padding: 20px;
    }


    input{
        border: none;
    }
    .inputt{
        padding: 10px;
        background-color: transparent;
        margin: 15px;
        height: 5vh;
        width: 50%;
        outline: none;
        border-bottom: 3px solid white;
        color: white;

    }

    .inputt:hover{
        background-color: rgba(255, 255, 255, 0.1);
    }

    .forgot{
        margin-top: 20px;
        opacity: 0.5;
        cursor: pointer;
    }

    .forgot:hover{
        opacity: 1;
    }

    .submit{
        user-select: none;
        cursor: pointer;
        align-self: flex-end;
        border-radius: 50%;
        margin-right: 10%;
        margin-top: 10%;
        width: fit-content;
        height: auto;
        padding: 15px;
        border-radius: 106px;
        background: #262626;
        box-shadow:  9px 9px 18px #111111,
             -9px -9px 18px #3b3b3b;
    }

    .resetModal{
        background-color: rgba(10, 10, 10, 0.90);
        width: 100vw;
        height: 100vh;
        display: none;
        position: fixed;
        top: 0;
        left: 0;
        align-items: center;
        justify-content: center;
        flex-direction: column;
    }

    .resetInput{
        padding: 5px 20px;
        color: white;
        width: 80vw;
        height: 8vw;
        border: none;
        border-bottom: white solid 5px;
        background-color: transparent;
        font-size: 3rem;
        outline: none;
    }

    .rst-btn{
        font-size: 2.5rem;
        padding: 8px;
        outline: none;
        background-color: whitesmoke;
        color: black;
        font-family: 'Poppins', sans-serif;
        font-weight: 400;
        border-radius: 15px;

    }

    .rst-btn:hover{
        background-color: white;
        
    }


</style>